import { css } from '@emotion/react';

export const submissionNameStyle = css`
  display: inline-flex;
  overflow: hidden;

  > span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
